var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11117 14.3881C8.50112 14.7738 9.12903 14.7735 9.51853 14.3873L19.2869 4.70171C19.6802 4.31168 19.6816 3.67619 19.2899 3.28449L17.2989 1.2935C16.9067 0.9013 16.2702 0.903235 15.8804 1.29782L9.52845 7.72748C9.13624 8.12449 8.49497 8.12364 8.10381 7.72559L4.11959 3.67123C3.73009 3.27488 3.09217 3.2721 2.69923 3.66504L0.710946 5.65332C0.318925 6.04534 0.320648 6.68146 0.714785 7.07135L8.11117 14.3881Z",
    fill: "url(#paint0_linear_3549_42204)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3549_42204",
    x1: -1.3,
    y1: 19.4353,
    x2: 23.9474,
    y2: 7.32513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.db3217e5bdf5075a7713e1a554ae4b84.svg";
export { ForwardRef as ReactComponent };